module.exports = "<div class=\"alert alert--info\" ng-if=!$ctrl.response> <p>Attempting to connect your Stripe account!</p> </div> <div ng-if=$ctrl.response class=\"alert alert--success\" ng-class=\"{ 'alert--fail' : $ctrl.error }\"> <p ng-bind=$ctrl.response></p> </div> <div class=\"row align-center\"> <a class=\"button button--large round\" ui-sref=\"app.admin.property-edit({property: $ctrl.id})\">Return to Property</a> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/property/views/payment.connect.html
// module id = 665
// module chunks = 0